// Metric event names
export enum MetricEvent {
  AI_TUTOR_CHAT_SAVE_FAIL = 'AI_TUTOR_CHAT_SAVE_FAIL',
  AI_TUTOR_CHAT_FETCH_FAIL = 'AI_TUTOR_CHAT_FETCH_FAIL',
  GOOGLE_BLOCKLY_GET_CODE_ERROR = 'BLOCKLY_GET_CODE_ERROR',
  CDO_BLOCKLY_GET_CODE_ERROR = 'CDO_BLOCKLY_GET_CODE_ERROR',
}
